export class IndividualProfessionTypeReferenceModel {
    public individualProfessionTypeCode: string;
    public individualProfessionTypeName: string;
    public sortSequence: number;
}